import React, { useState, useEffect } from 'react';
import { IoIosArrowBack, IoIosArrowForward, IoIosRadioButtonOff, IoIosRadioButtonOn } from 'react-icons/io';
import './style.css';
import FrameL from '../FrameL';

let interval;

const ImageCarousel = ({ children, ratio = "21:9", ratioAboveSm, ratioAboveMd, ratioAboveLg, ratioAboveXl, autoPlaySpeed, className }) => {
    const [index, setIndex] = useState(0);

    const handleForward = () => {
        setIndex(i => (i + 1) % children.length);
    }

    const handlePrevious = () => {
        setIndex(i => (i - 1 + children.length) % children.length);
    }

    useEffect(() => {
        if (autoPlaySpeed) {
            interval = setInterval(() => {
                handleForward();
            }, autoPlaySpeed);
        }
        
        return () => {
            clearInterval(interval);       
        }
    }, []);

    return (<FrameL className={className}
        hasImage={false}
        ratio={ratio}
        ratioAboveSm={ratioAboveSm}
        ratioAboveMd={ratioAboveMd}
        ratioAboveLg={ratioAboveLg}
        ratioAboveXl={ratioAboveXl}>
            <div>
                {children.map((child, i) => {
                    return <div key={i} className={`absolute inset-0 carousel-item ${index === i ? 'active' : ''}`}>
                        {child}
                    </div>
                })}

                <div className="absolute bottom-0 w-full mb-4 text-white text-3xl flex flex-row justify-center">
                    {children.map((_, i) => {
                        if (index !== i) {
                            return <IoIosRadioButtonOff key={i}></IoIosRadioButtonOff>
                        }
                        return <IoIosRadioButtonOn key={i}></IoIosRadioButtonOn>
                    })}
                </div>
                <IoIosArrowBack
                    className="absolute pointer-cursor carousel__prev text-white text-6xl"
                    onClick={handlePrevious} role="presentation" tabIndex="0"></IoIosArrowBack>
                <IoIosArrowForward
                    className="absolute pointer-cursor carousel__next text-white text-6xl"
                    onClick={handleForward} role="presentation" tabIndex="0" ></IoIosArrowForward>
            </div>
    </FrameL>
    );
};

ImageCarousel.defaultProps = {
    autoPlaySpeed: 6000
};

export default ImageCarousel;
